import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Classification.scss';
import { ClassificationSelector } from './reducers/ClassificationReducer';
import ClassificationSearch from './ClassificationSearch';
import ClassificationTable from './ClassificationTable';
import CompanyNameCombine from '../CompanyNameCombine/CompanyNameCombine';

const Classification: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const classificationViewData = useSelector(ClassificationSelector);

    useEffect(() => {
        document.title = "Classification";

    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item xs={12} lg={6}>
                    <ClassificationSearch></ClassificationSearch>
                    <Grid container className="datatable">
                        <ClassificationTable>
                        </ClassificationTable>
                    </Grid>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <CompanyNameCombine></CompanyNameCombine>
                </Grid>
            </Grid>
        </>
    )
};

export default Classification;